import React, { useEffect, useState } from 'react'
import { Carousel, Col, Row, Skeleton } from 'antd'
import { Link } from 'react-router-dom';
import customerDashboardService from '../../../services/customer-dashboard-service';
import { LuTruck } from "react-icons/lu";
import { BsPatchCheck } from "react-icons/bs";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { TiDeleteOutline } from "react-icons/ti";
import { GoKey } from "react-icons/go";
import { MdOutlineDirectionsCar } from "react-icons/md";
import { LuFolderSearch2 } from "react-icons/lu";
import { FaRegFileAlt } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { IoIosArrowForward } from 'react-icons/io';
import CustomerInvoices from '../customerinvoices';
import { changeDocumentTitle } from '../../../utils/title';

function CustomerDashbroad() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const cardData = [
        { title: 'Vehicles at Yard', count: data.total_vehicles_yard, imgSrc: <LuTruck style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/atvechile' },
        { title: 'Vehicles with Title at Yard', count: data.total_vehicles_with_title, imgSrc: <BsPatchCheck style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/atvechile' },
        { title: 'Vehicles without Title at Yard', count: data.total_vehicles_without_title, imgSrc: <TiDeleteOutline style={{ padding: 4, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/atvehicle-without-title' },
        { title: 'Vehicles without Keys at Yard', count: data.total_vehicles_without_keys, imgSrc: <GoKey style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/atvehicle-without-key' },
        { title: 'BOS Vehicles at Yard', count: data.total_bos_vehicles, imgSrc: <LuFolderSearch2 style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/vehicle-with-bos' },
        { title: 'Vehicles in Load Plan', count: data.total_vehicles_load_plan, imgSrc: <FaRegFileAlt style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/vehicle-loadplan' },
        { title: 'Other Vehicles', count: data.total_other_vehicles, imgSrc: <MdOutlineDirectionsCar style={{ padding: 6, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: '/customers-portal/other-vehicles' },
        { title: 'Vehicles Loaded', count: data.total_vehicles_loaded, imgSrc: <HiOutlineCheckCircle style={{ padding: 4, backgroundColor: "#FDE5E7", color: "#C10007", fontSize: "40px", borderRadius: "8px" }} />, path: "/customers-portal/loaded-vehicle" },
    ];

    const loadedCustomerDashboard = async () => {
        setLoading(true);
        const { success, data } = await customerDashboardService.fetchDashbord();
        if (success) {
            setData(data);
        }
        setLoading(false);
    }

    useEffect(() => {
        changeDocumentTitle("Dashboard");
        loadedCustomerDashboard();
    }, [])

    const banners = data?.customer_banners || [];

    return (
        <>
            <Carousel
                autoplay={banners.length > 0}
                autoplaySpeed={5000}
                centerMode
                dots={banners.length > 0}
                centerPadding="4px"
                style={{ width: "100%", height: "40%" }}
            >
                {loading ? (
                    <div className="carousel-skeleton p-1">
                        <Skeleton.Image
                            active
                            style={{ width: '1000px', height: '200px' }}
                        />
                    </div>
                ) : banners.length > 0 ? (
                    banners.map((banner, index) => (
                        <div className="p-1" key={index}>
                            <div className="carousel-image-wrapper">
                                <img src={banner} alt="Customer" className="carousel-image" />
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="p-1">
                        <div className="carousel-placeholder">
                            <span>No updates to show right now<br />Please check back soon</span>
                        </div>
                    </div>
                )}
            </Carousel >

            <div>
                <h1 className='mt-5 mb-6 mx-1 text-sm font-normal uppercase flex items-center gap-2'><span><GoDotFill style={{ color: "#B83D3D" }} /></span>Vehicle Status</h1>
                <Row gutter={[24, 24]}>
                    {cardData.map((data, index) => (
                        <Col span={6} key={index}> {/* This will ensure only 3 cards per row */}
                            {/* <Link to={data.path}> */}
                            <div className='p-3 bg-white h-24 border-[#D9D9D9] border rounded-xl hover:text-primary'>
                                <div className="flex gap-5 ">
                                    {data.imgSrc}
                                    <div className='hover:text-primary'>
                                        <h1 className='text-[11px]'>{data.title}</h1>
                                        <h2 className="text-3xl">{data.count}</h2>
                                    </div>
                                </div>
                            </div>
                            {/* </Link> */}
                        </Col>
                    ))}
                </Row>
            </div>
            <div>
                <div className='mb-10'>
                    {/* BALANCE STATUS + RECENT INVOICES SECTION */}
                    <div className='flex gap-x-56 '>
                        <h1 className='mt-5 mb-6 mx-1 text-sm font-normal uppercase flex items-center gap-2'>
                            <span><GoDotFill style={{ color: "#B83D3D" }} /></span>
                            Balance Status
                        </h1>
                        <h1 className='mt-5 mb-6 mx-1 text-sm font-normal uppercase flex items-center gap-2'>
                            <span><GoDotFill style={{ color: "#B83D3D" }} /></span>
                            Recent Invoices
                        </h1>

                    </div>

                    <Row gutter={[24, 24]} className="items-stretch">
                        {/* LEFT CARD */}
                        <Col span={8} className="flex">
                            <div className="p-6 bg-white border-[#D9D9D9] border rounded-xl flex flex-col justify-around w-full">
                                <h1 className="text-sm">Total Unpaid Balance</h1>
                                <h2 className="text-2xl flex gap-2 items-center">
                                    ${data.total_unpaid_invoices}
                                    <span className="text-xs">as of today</span>
                                </h2>
                                <Link to={"/invoice"}>
                                    <p className="text-sm font-normal flex items-center gap-1 text-primary">
                                        View All Invoices <span><IoIosArrowForward /></span>
                                    </p>
                                </Link>
                            </div>
                        </Col>

                        {/* RIGHT SIDE */}
                        <Col span={16}>
                            <CustomerInvoices showSearch={false} pag={false} limit={3} showAction={false} />
                        </Col>
                    </Row>
                </div>

            </div>
            {/* <div className="flex flex-col gap-12 mt-10">
                <AtYardVehicle atyard={data.at_yard_vehicles} />
            </div> */}
            <style>
                {`
                   .carousel-image-wrapper {
                      width: 100%;
                      height: 200px;
                      border-radius: 16px;
                      overflow: hidden; /* 🔑 THIS FIXES THE BUG */
                    }

                    .carousel-image {
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                    }

                    /* Placeholder styling */
                    .carousel-placeholder {
                      width: 100%;
                      height: 200px;
                      border-radius: 16px;
                      background: #f2f2f2;
                      color: #888;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      text-align: center;
                      font-size: 14px;
                      font-weight: 500;
                    }
                      
                    .carousel-skeleton {
                      width: 100%;
                      height: 200px;
                      border-radius: 16px;
                      overflow: hidden;
                    }

                    .carousel-skeleton .ant-skeleton-image {
                      width: 100%;
                      height: 200px;
                      border-radius: 16px;
                    }`
                }
            </style>
        </>

    )
}

export default CustomerDashbroad
